<template>
  <div>
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-4 sm:mb-6">
      <h1 class="text-2xl sm:text-3xl font-bold">{{ isEdit ? 'แก้ไขหมวดหมู่' : 'สร้างหมวดหมู่ใหม่' }}</h1>
      <router-link to="/admin/categories" class="text-gray-600 hover:text-gray-900 text-sm sm:text-base">
        &larr; กลับไปหน้ารายการ
      </router-link>
    </div>

    <div class="bg-white rounded-lg shadow p-4 sm:p-6 max-w-xl mx-auto">
      <Form @submit="saveCategory" :validation-schema="schema" :initial-values="form" v-slot="{ errors, isSubmitting }">
        <div class="space-y-4">
            <div>
                <label class="block text-gray-700 mb-1 text-sm sm:text-base">ชื่อหมวดหมู่</label>
                <Field 
                    name="name" 
                    type="text" 
                    class="w-full border rounded px-3 sm:px-4 py-2 text-sm sm:text-base"
                    :class="{ 'border-red-500': errors.name }"
                />
                <ErrorMessage name="name" class="text-red-500 text-xs sm:text-sm mt-1" />
            </div>

            <div class="flex items-center pt-2">
                <Field 
                    name="is_active" 
                    type="checkbox" 
                    :value="true" 
                    :unchecked-value="false"
                    class="mr-2 h-5 w-5" 
                />
                <label class="text-gray-700 text-sm sm:text-base">เปิดใช้งาน</label>
            </div>

            <div class="pt-4 flex flex-col sm:flex-row justify-end gap-3">
                <router-link to="/admin/categories" class="px-4 py-2 border border-primary-300 rounded text-primary-600 hover:bg-primary-50 font-medium text-center text-sm sm:text-base order-2 sm:order-1">ยกเลิก</router-link>
                <button 
                    type="submit" 
                    class="px-6 py-2 bg-primary text-white rounded font-bold hover:bg-primary-dark disabled:opacity-50 text-sm sm:text-base order-1 sm:order-2"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? 'กำลังบันทึก...' : 'บันทึก' }}
                </button>
            </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '../../api';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import { useNotification } from '../../composables/useNotification';

const route = useRoute();
const router = useRouter();
const { showSuccess, showError, handleApiError } = useNotification();

const isEdit = computed(() => !!route.params.id);
const form = ref({
    name: '',
    is_active: true
});

const schema = yup.object({
    name: yup.string().required('กรุณากรอกชื่อหมวดหมู่'),
    is_active: yup.boolean()
});

onMounted(async () => {
    if (isEdit.value) {
        try {
            const response = await api.get(`/admin/categories/${route.params.id}`);
            const data = response.data.data;
            form.value = {
                name: data.name,
                is_active: Boolean(data.is_active)
            };
        } catch (error) {
            showError('ไม่สามารถโหลดข้อมูลหมวดหมู่ได้');
            router.push('/admin/categories');
        }
    }
});

const saveCategory = async (values, { setErrors }) => {
    try {
        if (isEdit.value) {
            await api.put(`/admin/categories/${route.params.id}`, values);
            showSuccess('อัปเดตหมวดหมู่เรียบร้อยแล้ว');
        } else {
            await api.post('/admin/categories', values);
            showSuccess('สร้างหมวดหมู่เรียบร้อยแล้ว');
        }
        router.push('/admin/categories');
    } catch (error) {
        handleApiError(error, setErrors);
    }
};
</script>